import React from 'react';
import { Text } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

// For fixing items that don't camel case well in the database.
const map = {
    'apneaMachine': 'Apnea Machine (CPAP)',
    'artificialEyeLimb': 'Artificial Eye/Limb',
    'artificialEyeLimbRepairReplacement': 'Artificial Eye/Limb Repair/Replacement',
    'glucoseMonitoringEquipmentSupplies': 'Glucose Monitoring Equipment and Supplies',
    'tensMachine': 'TENS Machine',
    'wheelchairManual': 'Wheelchair - Manual',
    'wheelchairElectric': 'Wheelchair - Electric',
    'orthopedicShoesMaximum': 'Orthopedic Shoes',
    'orthopedicShoesPairsPerYear': 'Orthopedic Shoes'
};

/**
 * 
 * @param {*} item 
 * @param {*} coverage 
 * @returns 
 */
const _renderPercentItem = (item, coverage) => (
    <div key={item} style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', marginTop: "5px"}}>
        <Text small customStyle={{ flex: 1 }}>
            {helpers.camelToNormalCase(item)}
        </Text>
        <Text small>{ `${ coverage[item] }%` }</Text>
    </div>
);

/**
 * 
 * @param {*} item 
 * @param {*} coverage 
 * @returns 
 */
const _renderDaysItem = (item, coverage) => (
    <div key={item} style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', marginTop: "5px"}}>
        <Text small customStyle={{ flex: 1 }}>
            {helpers.camelToNormalCase(item)}
        </Text>
        <Text small>{coverage[item]}</Text>
    </div>
);

/**
 * 
 * @param {*} item 
 * @param {*} coverage 
 * @returns 
 */
const _renderItem = (item, coverage) => {
    return(
        <div key={item} style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', marginTop: "5px"}}>
            <Text small customStyle={{ flex: 1 }}>
                {map[item] ? map[item] : helpers.camelToNormalCase(item)}
            </Text>
            <Text small>{ `$${ helpers.numberWithCommasDecimals(coverage[item]) }` }</Text>
        </div>
    );
};

/**
 * 
 * @param {*} item 
 * @param {*} coverage 
 * @returns 
 */
const _renderUnitItem = (item, coverage) => {
    return(
        <div key={item} style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', marginTop: "5px"}}>
            <Text small customStyle={{ flex: 1 }}>
                {map[item] ? map[item] : helpers.camelToNormalCase(item)}
            </Text>
            <Text small>{ `${ coverage[item] } ${coverage[item] === 1 ? 'Unit' : 'Units'}` }</Text>
        </div>
    )
}

/**
 * 
 * @param {*} item 
 * @param {*} coverage 
 * @returns 
 */
const _renderPair = (item, coverage) => {
    return(
        <div key={item} style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', marginTop: "5px"}}>
            <Text small customStyle={{ flex: 1 }}>
                {map[item] ? map[item] : helpers.camelToNormalCase(item)}
            </Text>
            <Text small>{ `$${ helpers.numberWithCommasDecimals(coverage[item]) }` }</Text>
        </div>
    )
}

/**
 * 
 * @param {*} item 
 * @param {*} coverage 
 * @returns 
 */
const _renderProstheticsGrouping = (item, coverage) => {
    return(
        <div key={item}>
            <div style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', marginTop: "5px"}}>
                <Text small customStyle={{ flex: 1 }}>{ helpers.camelToNormalCase(item) }</Text>
                <Text small>{ `$${ helpers.numberWithCommasDecimals(coverage[item]) }` }</Text>
            </div>
            <div style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', marginTop: "5px", marginLeft: "15px"}}>
                <Text small customStyle={{ flex: 1 }}>Artificial Eye/Limb</Text>
                <Text small>1 Initial prosthesis</Text>
            </div>
            <div style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', marginTop: "5px", marginLeft: "15px"}}>
                <Text small customStyle={{ flex: 1 }}>Artificial Eye/Limb</Text>
                <Text small>{ `Repair & replacement $${ helpers.numberWithCommasDecimals(coverage.artificialEyeLimbRepairReplacement || 0) }` }</Text>
            </div>
            <div style={{display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', marginTop: "5px", marginLeft: "15px"}}>
                <Text small customStyle={{ flex: 1 }}>Surgical Bra</Text>
                <Text small>Limited to 2</Text>
            </div>
        </div>
    )
}

/**
 *
 * @param {*} coverage
 */
const CoverageBlockMedical = ({ coverage }) => {
    const excludedKeywords = [
        'Ends',
        'Deductible',
        'deductible',
        'Period',
        'Age',
        'Date',
        'Week',
        'Survivor',
        'reimbursement',
        'combinedMaximum',
        'laserEye',
        'genderAffirmation',
        'orthopedicShoes',
        'artificialEyeLimb', // part of prosthetics grouping
        ...(coverage.privateHospital === 2 
            ? [ 'privateHospital', 'hospitalBenefitsReimbursement' ] // hide these if 'None' is selected for Hospital Benefits Type in the plan design
            : []
        )
    ];

    const itemsToRender = Object.keys(coverage).map((item) => {
        const isExcludedItem = excludedKeywords.some(keyword => item.includes(keyword));

        if ((typeof coverage[item] === 'number' && coverage[item] > 1 && !isExcludedItem) ||
            (item === 'orthopedicShoesPairsPerYear' && coverage.orthopedicShoesMaximumType === 'pairs' && coverage.includeOrthopedicShoes) ||
            (item === 'orthopedicShoesMaximum' && coverage.orthopedicShoesMaximumType === 'dollar' && coverage.includeOrthopedicShoes)
        ) {
            if ((item.includes("hospitalBenefits") && coverage.privateHospital !== 2) ||
                item.includes("convalescentHospitalReimbursement") ||
                item.includes("diagnosticServicesReimbursement") ||
                item.includes("dentalAccidentReimbursement") ||
                item.includes("medicalReferralReimbursement")
            ) {
                return _renderPercentItem(item, coverage);
            }

            if (item.includes("convalescentHospitalMaxDays")) {
                return _renderDaysItem(item, coverage);
            }

            if (item === "prosthetics") {
                return _renderProstheticsGrouping(item, coverage)
            }

            if (item === "orthopedicShoesPairsPerYear") {
                return _renderPair(item, coverage);
            }

            return _renderItem(item, coverage);
        }

        return true;
    })
    return itemsToRender
};

export default (CoverageBlockMedical);